import { LoaderCircle } from '@skytech/ui'
import { useQuery } from '@tanstack/react-query'

import { useTranslation } from '@/app/translations/translations-hooks'
import { useNewPolicyContext } from '@/modules/ecom-policy/new/index.context'
import queries from '@/modules/ecom-policy/queries'
import { ecomPolicyResources } from '@/modules/ecom-policy/resources'

import ClassificationTile from './ClassificationTile'

const StepType = () => {
  const translate = useTranslation()

  const { data, isLoading } = useQuery(
    queries.categoryClassification(),
    ecomPolicyResources.getCategoryClassification
  )
  if (isLoading) {
    return <LoaderCircle />
  }

  const classifications =
    data?.map(classification => ({
      symbol: classification.id,
      label: translate(classification.name),
    })) || []

  const [selectedClassifications, setSelectedClassifications] =
    useNewPolicyContext().selectedClassifications

  return (
    <div className="m-4 mb-8 grid gap-8 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {classifications.map(classificationsListItem => (
        <ClassificationTile
          key={classificationsListItem.symbol}
          symbol={classificationsListItem.symbol}
          label={classificationsListItem.label}
          selectedClassifications={selectedClassifications}
          setSelectedClassifications={setSelectedClassifications}
        />
      ))}
    </div>
  )
}

export default StepType
